// extracted by mini-css-extract-plugin
module.exports = {"container":"TrackingNumber_container__QQZnn","imgWrapper":"TrackingNumber_imgWrapper__O2J4t","carrierImg":"TrackingNumber_carrierImg__YZFHi"};